import { render, staticRenderFns } from "./PublishTab.vue?vue&type=template&id=2aad5c5e&scoped=true"
import script from "./PublishTab.vue?vue&type=script&lang=js"
export * from "./PublishTab.vue?vue&type=script&lang=js"
import style0 from "./PublishTab.vue?vue&type=style&index=0&id=2aad5c5e&prod&scoped=true&lang=css"
import style1 from "./PublishTab.vue?vue&type=style&index=1&id=2aad5c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad5c5e",
  null
  
)

export default component.exports